const pub = [{
    path: 'index',
    name: 'indexHome',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "indexHome" */ '../views/pub/index.vue')
  }, {
    path: 'login',
    name: 'login',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "login" */ '../views/pub/login.vue')
  },
  {
    path: 'forgot',
    name: 'forgot',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "forgot" */ '../views/pub/forgot.vue')
  },
  {
    path: 'reg/hospital',
    name: 'regHospital',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "regHospital" */ '../views/pub/regHospital.vue')
  },
  {
    path: 'reg/personal',
    name: 'regPersonal',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "regPersonal" */ '../views/pub/regPersonal.vue')
  },
  {
    path: 'reg/lab',
    name: 'regLab',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "regLab" */ '../views/pub/regLab.vue')
  },
  {
    path: 'resetpwbe',
    name: 'resetpwbe',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "resetpwbe" */ '../views/pub/resetPWByEmail.vue')
  }
];
export default pub;